import React from 'react';
import s from './FillForm.module.scss';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions  from '@material-ui/core/DialogActions';
import SuccessIcon from '@material-ui/icons/CheckCircleTwoTone';

export function FillForm(props) {

    return (<> 
        <DialogTitle>
                <div className={'row'}>
                    <div className="col-1 text-right">
                        
                    </div>
                    <div className="col-10 p-1 text-center">
                        <SuccessIcon
                            className={`text-success font-weight-bold ${s.fadeIn}`}
                            fontSize={'large'}
                        />
                    </div>
                </div>
                <div className={'row'}>
                    <div className="col-12 text-center">
                    <Typography variant='h5' align='center' >
                        پرداخت موفق
                    </Typography>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className='p-3 text-center'>
                <div className="row">
                    <div className="col-">
                        <Typography variant='body2' className='font-weight-bold text-center p-3' align='center'>
                            برای دریافت کد رهگیری و تکمیل مرحل لطفا در فرم نظرسنجی شرکت کنید
                        </Typography>
                    </div>
                </div>
            </DialogContent>
            <DialogActions dir='ltr' className='p-3'>
                <Button 
                    className='font-weight-bold m-auto mt-2 mb-2' 
                    variant='contained' 
                    color='secondary' 
                    onClick={props.Close}
                    >
                    شرکت در فرم نظر سنجی 
                </Button>
            </DialogActions>
    </>)
}

export default FillForm;
